import { useState, useEffect } from 'react';
import { validateNumericValue } from './numericValidation';
export const useNumericValidation = ({ value, min, max, step, precision, validationCallback }) => {
    const [validationError, setValidationError] = useState(null);
    useEffect(() => {
        const validationParams = {
            value,
            min,
            max,
            step,
            precision
        };
        let error = validateNumericValue(validationParams);
        if (error === null && !isNullOrUndefined(validationCallback)) {
            error = validationCallback(validationParams);
        }
        setValidationError(error);
    }, [value, min, max, step, precision, validationCallback]);
    const handleValidationChange = (error) => {
        setValidationError(error);
    };
    return {
        validationError,
        handleValidationChange
    };
};
